import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ShieldAlert, ShieldCheck } from "lucide-react";

export const Compliance = () => {
  const { data } = useQuery({
    queryKey: ["compliance"],
    queryFn: async () => (await api.get("/compliance")).data,
  });
  const items = data || [];

  return (
    <div className="space-y-6" data-testid="page-compliance">
      <header>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#7C93A5]">Compliance360™</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Compliance Watchtower</h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">Lowest-scoring licences prioritised for escalation.</div>
      </header>
      <div className="cad-panel overflow-hidden">
        <table className="w-full text-[13px]">
          <thead>
            <tr className="text-left border-b cad-hairline">
              {["Licence","Applicant","Commodity","Province","Score","Expiry","Signal"].map((h) => (
                <th key={h} className="px-3 py-2.5 font-mono-cad text-[10px] uppercase tracking-[0.18em] text-[#7C93A5]">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="cad-tbody">
            {items.map((c) => (
              <tr key={c.id} data-testid={`compliance-row-${c.id}`}>
                <td className="px-3 py-2 font-mono-cad text-[#F6F8FA]">{c.licence_number || "—"}</td>
                <td className="px-3 py-2 text-[#DCE3E8]">{c.applicant}</td>
                <td className="px-3 py-2">{c.commodity}</td>
                <td className="px-3 py-2">{c.province}</td>
                <td className="px-3 py-2 font-mono-cad">
                  <div className="flex items-center gap-2">
                    <div className="w-24 h-1.5 bg-[#18232D] rounded-full overflow-hidden">
                      <div className="h-full" style={{
                        width: `${c.compliance_score}%`,
                        background: c.compliance_score >= 75 ? "#6BB88A" : c.compliance_score >= 50 ? "#C99A2E" : "#A93F3F",
                      }} />
                    </div>
                    <span>{c.compliance_score}</span>
                  </div>
                </td>
                <td className="px-3 py-2 font-mono-cad text-[#B3C2CC]">{(c.expiry_date || "").slice(0, 10)}</td>
                <td className="px-3 py-2">
                  {c.compliance_score >= 75
                    ? <span className="cad-chip cad-chip-green"><ShieldCheck size={11}/> Nominal</span>
                    : c.compliance_score >= 50
                      ? <span className="cad-chip cad-chip-gold"><ShieldAlert size={11}/> Watch</span>
                      : <span className="cad-chip cad-chip-red"><ShieldAlert size={11}/> Escalate</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
